module.exports = __webpack_public_path__ + "static/media/starfire.dca95f70.md";